export default __webpack_public_path__ + "static/media/icon-role-Sponsor.239538b9.svg";